import { Component, OnInit, Input } from '@angular/core';
import { DependenciaModel } from 'src/app/models/dependencia.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { UrlService } from 'src/app/shared/services/url.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { GlobalService } from 'src/app/shared/global.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { reporteInformeVisitante } from 'src/app/models/reporteInformeVisitante.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { HttpResponseBase } from '@angular/common/http';
import { UtilService } from 'src/app/shared/services/util.service';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import { DetalleDominio } from 'src/app/models/detalleDominio.Model';
import * as moment from 'moment';
import { AdministrarFuncionarioDTO } from 'src/app/models/administrarFuncionario.model';
import { isUndefined } from 'util';

@Component({
    selector: 'app-generar-reporte-uso-bicicleta',
    templateUrl: './generar-reporte-uso-bicicleta.component.html',
    styleUrls: ['./../generar-reportes-funcionarios.component.scss']
})

export class GenerarReporteUsoBicicletaComponent implements OnInit {

    @Input() public dependencia: DependenciaModel[];
    @Input() reporteInformeVisitante: reporteInformeVisitante[];

    public dominios: DetalleDominio[] = [];
    public filtroTipoDoc: string;
    public dominioTiposDocumento: DetalleDominio[] = [];
    public filtroTipoTransporte: string;
    public dominioTiposTransporte: DetalleDominio[] = [];
    public dominiosTipoVinculacion: DetalleDominio[] = [];
    public dominioSedes: DetalleDominio[] = [];
    public listaDependencias: any;
    public filtroDocumento: string;
    public filtroTipoVinculacion: string;
    public filtroSede: string;
    public filtroDependencia: string;
    public filtroNombre: string;
    public filtroFechaInicio: Date;
    public filtroFechaFin: Date;
    public placeholderDate: string;
    public funcionarios: AdministrarFuncionarioDTO[] = [];
    guardarCampoVinculacion: boolean;

    public validar = false;
    public datosArchivo: any;

    public listaDominios: string[] = [DominiosService.DOMINIO_TIPO_FUNCIONARIO,
        DominiosService.DOMINIO_TIPO_IDENTIFICACION, DominiosService.DOMINIO_SEDE, DominiosService.DOMINIO_TIPO_VEHICULO];

    constructor(
        private global: GlobalService,
        private urlService: UrlService,
        private spinner: NgxSpinnerService,
        private alertService: AlertService,
        private utilService: UtilService
    ) { }

    ngOnInit() {

        this.placeholderDate = ConstantesService.SELECCION_FECHA;
        this.consultarDominios();
        this.obtenerDependencia();
    }

    /**
     * Consulta los dominios para traer el tipo de documento
     */
    public consultarDominios() {
        this.spinner.show();
        const serviceProvider = 'consultarDominios';
        const url = this.urlService.getUrlTransversal(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_TRANS);
        this.global.postGenerico(url, this.listaDominios).subscribe(
            data => {
                this.dominios = data;
                this.filtrarDominios(this.dominios);
                this.spinner.hide();
            }, err => {
                this.catchException('Ocurrio un error en la consulta de los dominios');
            }
        );
    }

    /**
     * Método que recolecta los filtros y realiza el llamado del servicio correspondiente
     * al BACKEND y obtiene el resultado de la consulta deseada
     */
    generarReporteUsoBicicleta() {

        this.spinner.show();
        if (this.filtroTipoDoc && !this.filtroDocumento) {
            this.validar = false;
            this.catchException('Por favor ingrese el “Número de documento”');
            return;
        }
        if (this.filtroDocumento && this.filtroDocumento.length > 0 && !/^([A-Z0-9])*$/.test(this.filtroDocumento)) {
            this.catchException('Por favor ingrese nuevamente un “Número de documento”');
            this.catchException('La información ingresada en “Número de documento”'
                + 'no corresponde con lo solicitado, por favor verifique');
            document.getElementById('numeroDocumento').focus();
            return;
        }

        if (this.filtroFechaInicio.getTime() > this.filtroFechaFin.getTime()) {
            this.catchException('La fecha inicial no puede ser mayor a la fecha inicial');
            return;
        }
        if (this.filtroTipoVinculacion === 'Ambos') {
            this.filtroTipoVinculacion = undefined;
            this.guardarCampoVinculacion = true;
        }
        const filtros = {
            filtroTipoDocumento: this.filtroTipoDoc,
            filtroDocumento: this.filtroDocumento,
            filtroTipoVinculacion: this.filtroTipoVinculacion,
            filtroSede: this.filtroSede,
            filtroDependencia: this.filtroDependencia,
            filtroNombre: this.filtroNombre,
            filtroFechaInicio: this.filtroFechaInicio,
            filtroFechaFin: this.filtroFechaFin,
            filtroTipoTransporte: this.filtroTipoTransporte
        };
        const serviceProvider = 'reporteUsoBicicleta';
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, null),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.postGenerico(url, filtros).subscribe(
            data => {
                this.datosArchivo = data;
                this.spinner.hide();
                this.alertService.generateAlertSuccess('Su reporte se está descargando', '');
                this.descargarArchivo();
            }, err => {
                  if (err.status === 500) {
                    this.catchException(err.error.message);
                } else {
                    this.catchException('El reporte no se ha podido generar');
                }
            }
        );

        if (this.guardarCampoVinculacion) {
            this.filtroTipoVinculacion = 'Ambos';
            this.guardarCampoVinculacion = false;
        }
    }

    /**
     * Método que convierte el archivo Excel y realiza la descarga del mismo
     */
    descargarArchivo() {
        ConstantesService.descargarDocumento('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            , this.datosArchivo.nombre, this.datosArchivo.archivo);
        this.spinner.hide();
    }

    /**
     * Método de control de Excepciones
     * @param error                 mensaje saliente respecto al error ocurrido
     * @param err: HttpResponseBase Tipo de error
     */
    catchException(error) {
        this.utilService.cathException(error, this.alertService, this.spinner);
        this.spinner.hide();
    }

    /**
     * Metodo que valida los campos obligatorios para porder habilitar el boton Generar Reporte
     */
    validacion() {

        if (this.filtroFechaInicio && this.filtroFechaFin) {
            this.validar = true;
        } else {
            this.validar = false;
        }
        if (this.filtroNombre === '') {
            this.filtroNombre = undefined;
        }
        if (this.filtroTipoDoc === 'undefined') {
            this.filtroTipoDoc = undefined;
        }
        if (this.filtroDocumento === '') {
            this.filtroDocumento = undefined;
        }
        if (this.filtroTipoVinculacion === 'undefined') {
            this.filtroTipoVinculacion = undefined;
        }
        if (this.filtroSede === 'undefined') {
            this.filtroSede = undefined;
        }
        if (this.filtroDependencia === 'undefined') {
            this.filtroDependencia = undefined;
        }
        if (this.filtroTipoTransporte === 'undefined') {
          this.filtroTipoTransporte = undefined;
        }

    }

    /**
     * Metodo encargado de filtrar los dominios por cada una de las listas de seleccion
     * @function {filtrarDominios}
     * @param  {type} dominios: DetalleDominio[] {description}
     * @return {type} {description}
     */
    filtrarDominios(dominios: DetalleDominio[]) {

        this.dominioTiposDocumento = dominios.filter(dominio => dominio.detalleDominioPK.nombreDominio
            === DominiosService.DOMINIO_TIPO_IDENTIFICACION);
        this.dominiosTipoVinculacion = dominios.filter(dominio => dominio.detalleDominioPK.nombreDominio
            === DominiosService.DOMINIO_TIPO_FUNCIONARIO);
        this.dominioSedes = dominios.filter(dominio => dominio.detalleDominioPK.nombreDominio
            === DominiosService.DOMINIO_SEDE);
      this.dominioTiposTransporte = dominios.filter(dominio => dominio.detalleDominioPK.nombreDominio
        === DominiosService.DOMINIO_TIPO_VEHICULO);
    }

    /**
     * Metodo que realiza la consulta de las dependencias
     */
    obtenerDependencia() {
        this.spinner.show();
        const serviceProvider = 'ObtenerDependencias';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filterBy', 'sede=' + this.filtroSede]);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null,
            queryParams), this.urlService.hostAPI_FUNCIONARIOS);
        this.global.getGenerico(url).subscribe(
            data => {
                this.listaDependencias = data;
                this.spinner.hide();
            }, err => {
                this.catchException('No es posible obtener las dependencias');
            }
        );
    }

}
